"use client";

import React from "react";
import { MapPin, Phone, Mail } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function LetsSolveProblems() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="237054" id="join-the-paradise-party" className="bg-background py-16 md:py-24 overflow-hidden" ref={sectionRef}>
      <div className="container mx-auto px-4 md:px-6">
        <div className={`grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}
          <div className="flex flex-col space-y-8">
            <div>
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold font-default text-foreground tracking-tight mb-4">
                Join the Paradise Party
              </h2>
              <p className="text-lg text-muted-foreground max-w-md">
                Visit us at Fish Festival for the most refreshing treats and cocktails.
              </p>
            </div>

            <div className="flex flex-col space-y-6">
              {}
              <div className="flex items-start gap-4 group">
                <div className="bg-primary/10 p-3.5 rounded-xl text-primary transition-colors group-hover:bg-primary group-hover:text-primary-foreground shrink-0">
                  <MapPin className="w-6 h-6" />
                </div>
                <div className="pt-1">
                  <h3 className="font-semibold text-foreground font-default text-lg mb-1">
                    Our Location
                  </h3>
                  <p className="text-muted-foreground leading-relaxed cursor-pointer">
                    <Link to="https://maps.app.goo.gl/SAmxuQ7m3vv33rFi7" newTab className="hover:text-primary transition-colors">
                      V2F5+GX4, Sarandë, Albania
                    </Link>
                  </p>
                </div>
              </div>

              {}
              <div className="flex items-start gap-4 group">
                <div className="bg-primary/10 p-3.5 rounded-xl text-primary transition-colors group-hover:bg-primary group-hover:text-primary-foreground shrink-0">
                  <Phone className="w-6 h-6" />
                </div>
                <div className="pt-1">
                  <h3 className="font-semibold text-foreground font-default text-lg mb-1">
                    Call Us
                  </h3>
                  <Link to="tel:+355696863772" className="text-muted-foreground hover:text-primary transition-colors text-lg">
                    +355 69 686 3772
                  </Link>
                </div>
              </div>

              {}
              <div className="flex items-start gap-4 group">
                <div className="bg-primary/10 p-3.5 rounded-xl text-primary transition-colors group-hover:bg-primary group-hover:text-primary-foreground shrink-0">
                  <Mail className="w-6 h-6" />
                </div>
                <div className="pt-1">
                  <h3 className="font-semibold text-foreground font-default text-lg mb-1">
                    Say Hello
                  </h3>
                  <Link to="mailto:ksantiljang@gmail.com" className="text-muted-foreground hover:text-primary transition-colors text-lg">
                    ksantiljang@gmail.com
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {}
          <div className="relative w-full h-[400px] md:h-[500px] lg:h-[600px] rounded-2xl overflow-hidden shadow-2xl border border-border/50 group">
            {}
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678745/img/fish_festival_map.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678745/img/fish_festival_map.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678745/img/fish_festival_map.png-wvc-sizes" alt="Map showing V2F5+GX4, Sarandë, Albania location" className="absolute inset-0 w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105" loading="lazy" />
            
            {}
            <div className="absolute inset-0 bg-gradient-to-t from-background/40 to-transparent pointer-events-none" />

            {}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex flex-col items-center pointer-events-none">
              {}
              <div className="bg-background/95 backdrop-blur-sm px-4 py-2 rounded-lg shadow-lg border border-border mb-3 flex items-center gap-2.5 transform transition-transform duration-500 group-hover:-translate-y-1">
                <div className="relative flex h-3 w-3">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-lg bg-primary opacity-75"></span>
                  <span className="relative inline-flex rounded-lg h-3 w-3 bg-primary"></span>
                </div>
                <span className="font-semibold text-sm font-default text-foreground whitespace-nowrap">
                  V2F5+GX4, Sarandë, Albania
                </span>
              </div>
              
              {}
              <div className="relative">
                <MapPin className="w-12 h-12 text-primary drop-shadow-md transform transition-transform duration-500 group-hover:scale-110" fill="currentColor" strokeWidth={1} stroke="var(--background)" />
                <div className="absolute -bottom-2 left-1/2 -translate-x-1/2 w-4 h-1.5 bg-black/20 blur-[2px]"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}